<mat-toolbar class="app-header">
  <div class="app-header__container">
    <div class="app-header__platform">
      <div class="app-header__logo">
        <a href="https://www.thermofisher.com" target="_blank" rel="noopener noreferrer">
          <img
            src="/assets/images/thermo-fisher-scientific.svg"
            alt="Thermo Fisher Scientific Logo"
            class="app-header__logo-image"
          />
        </a>
      </div>
      <span class="app-header__title">Clinical Decision Suite</span>
    </div>

    <div class="app-header__utility">
      <div>
        <div class="app-header__sponsor">
          <client-switcher-dropdown
            *ngIf="showSponsorDropdown"
            #sponsorDd
            [sponsors]="sponsors"
            [sponsorSelected]="selectedSponsor"
            (applyClicked)="onSponsorApply($any($event))"
          ></client-switcher-dropdown>
        </div>
        <confirmation-modal
          [open]="switchOpen"
          [sponsor]="pendingSponsor"
          [title]="'Confirm switching sponsor'"
          confirmLabel="Yes, switch"
          cancelLabel="No, cancel"
          (closed)="onSponsorSwitchModalClosed($any($event))"
        >
        </confirmation-modal>
      </div>
      <div
        class="app-header__icon"
        [class.app-header__icon-button--active]="menuStateService.isMenuVisible()"
        (click)="onProfileClick($event)"
      >
        <mat-icon class="app-header__icon-svg" svgIcon="user"></mat-icon>
      </div>
    </div>
  </div>
</mat-toolbar>
